import { Device, User } from '.';
import { FolderConf } from './syncthing/folder-conf.model';

export class Application {
  public _id: string;
  public folderId: string;
  public createdAt: number;
  public updatedAt: number;
  public name: string;
  public description: string;
  public language: string;
  public thumbnailPath: string;
  public subscribedDevices: Device[];
  public owner: User;
  public paused: boolean;
  public size: number;
  public files: number;
  public directories: number;
  public devicesSubscribed: number;
  public completion?: {
    completion?: number; // percentage
    doneBytes?: number;
    doneItems?: number;
    doneFiles?: number;
    needBytes?: number;
    needFiles?: number;
    globalBytes?: number;
  };
}
